module.exports = __webpack_public_path__ + "public/img/add.89b3b80d.png";